
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function TrendingCompanies() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const createSlug = (name) =>
    name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

  useEffect(() => {
    fetch("https://api.niveshly.com/companies")
      .then(res => res.json())
      .then(data => {
        const trendingOnly = data.filter(c => c.trending === true);
        setCompanies(trendingOnly);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "20px"
        }}
      >
        {loading ? (
          <p>Loading companies...</p>
        ) : error ? (
          <p>Error: {error}</p>
        ) : companies.length === 0 ? (
          <p>No trending companies found.</p>
        ) : (
          companies.map(c => (
            <div
              key={c.id}
              onClick={() =>
                navigate(`/company/${c.id}/${createSlug(c.name)}`)
              }
              style={{
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                cursor: "pointer",
                position: "relative",
                transition: "transform 0.2s, box-shadow 0.2s"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 1px 3px rgba(0,0,0,0.1)";
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "15px" }}>
                <img
                  src={c.logo}
                  alt={c.name}
                  style={{
                    width: "60px",
                    height: "60px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb"
                  }}
                />
                <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1a202c", margin: 0 }}>
                  {c.name}
                </h2>
              </div>

              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "15px" }}>
                <span style={{
                  padding: "6px 12px",
                  backgroundColor: "#4f46e5",
                  color: "white",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "600"
                }}>
                  {c.price}
                </span>
                {c.trending && (
                  <span style={{
                    padding: "6px 12px",
                    backgroundColor: "#ef4444",
                    color: "white",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px"
                  }}>
                    🔥 Trending
                  </span>
                )}
                <span style={{
                  padding: "6px 12px",
                  backgroundColor: c.availability ? "#10b981" : "#ef4444",
                  color: "white",
                  borderRadius: "6px",
                  fontSize: "12px",
                  fontWeight: "600"
                }}>
                  Available: {c.availability ? "✅" : "❌"}
                </span>
              </div>

              <div style={{ marginBottom: "15px", fontSize: "14px", color: "#4b5563", lineHeight: "1.6" }}>
                <p style={{ margin: "5px 0" }}><strong>Minimum quantity:</strong> {c.quantity}</p>
                <p style={{ margin: "5px 0" }}><strong>ISIN:</strong> {c.isin}</p>
                <p style={{ margin: "5px 0" }}><strong>PAN Number:</strong> {c.pan}</p>
              </div>

              {/* <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                <button style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "#4f46e5",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "background-color 0.2s"
                }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#4338ca"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#4f46e5"}>
                  Inquire Now
                </button>

                <button style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "white",
                  color: "#4f46e5",
                  border: "2px solid #4f46e5",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#4f46e5";
                    e.currentTarget.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "white";
                    e.currentTarget.style.color = "#4f46e5";
                  }}>
                  Get Started
                </button>
              </div> */}

              <div style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                padding: "6px 12px",
                backgroundColor: "#f3f4f6",
                color: "#1a202c",
                borderRadius: "6px",
                fontSize: "12px",
                fontWeight: "600"
              }}>
                {c.tag}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
